import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UsualFeedbacksActions } from './usual-feedbacks.actions';
import { UsualFeedbackService } from '../../services/usual-feedback.service';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class UsualFeedbacksEffects {
  private actions$ = inject(Actions);
  private service = inject(UsualFeedbackService);
  private router = inject(Router);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.loadUsualFeedbacks),
      switchMap(() =>
        this.service.getAll().pipe(
          map(data => UsualFeedbacksActions.loadUsualFeedbacksSuccess({ data })),
          catchError(error =>
            of(UsualFeedbacksActions.loadUsualFeedbacksFailure({ error: error.message })))
        )
      )
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.createUsualFeedback),
      mergeMap(({ data }) =>
        this.service.create(data).pipe(
          map(created => UsualFeedbacksActions.createUsualFeedbackSuccess({ data: created })),
          catchError(error =>
            of(UsualFeedbacksActions.createUsualFeedbackFailure({ error: error.message })))
        )
      )
    )
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.updateUsualFeedback),
      mergeMap(({ id, data }) =>
        this.service.update(id, data).pipe(
          map(updated => UsualFeedbacksActions.updateUsualFeedbackSuccess({ data: updated })),
          catchError(error =>
            of(UsualFeedbacksActions.updateUsualFeedbackFailure({ error: error.message })))
        )
      )
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.deleteUsualFeedback),
      mergeMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => UsualFeedbacksActions.deleteUsualFeedbackSuccess({ id })),
          catchError(error =>
            of(UsualFeedbacksActions.deleteUsualFeedbackFailure({ error: error.message })))
        )
      )
    )
  );

  importCsv$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.importCsv),
      mergeMap(({ file }) =>
        this.service.importCsv(file).pipe(
          map(result => UsualFeedbacksActions.importCsvSuccess({ message: result.message })),
          catchError(error =>
            of(UsualFeedbacksActions.importCsvFailure({ error: error.message })))
        )
      )
    )
  );

  reloadAfterImport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.importCsvSuccess),
      map(() => UsualFeedbacksActions.loadUsualFeedbacks())
    )
  );

  navigateAfterCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.createUsualFeedbackSuccess),
      tap(() => this.router.navigate(['/lookups/usual-feedbacks']))
    ),
    { dispatch: false }
  );

  navigateAfterUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsualFeedbacksActions.updateUsualFeedbackSuccess),
      tap(() => this.router.navigate(['/lookups/usual-feedbacks']))
    ),
    { dispatch: false }
  );
}
